import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import ProfilePic from '../profilepic/ProfilePic';
import AccountHoverCard from '../profile/AccountHoverCard';
import '../ReviewComponent.css';

const formatDate = (value) => {
    if (!value) {
        return null;
    }
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
        return null;
    }
    const months = [
        'января', 'февраля', 'марта', 'апреля', 'мая', 'июня',
        'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря',
    ];
    const day = date.getDate();
    const monthIndex = date.getMonth();
    const year = date.getFullYear();
    return `${day} ${months[monthIndex]} ${year}`;
};

const MangaCommentComponent = ({ comment }) => {
    if (!comment) {
        return null;
    }

    const user = comment.user || comment.author || {};
    const userId = user.id
        || user.userId
        || user.uid
        || comment.userId
        || comment.user_id
        || comment.uid
        || comment.authorId
        || comment.author_id;
    const nickname = user.nickname
        || user.nick
        || comment.nickname
        || comment.nick
        || comment.username
        || 'Аноним';
    const text = comment.text || comment.message || '';
    const dateText = formatDate(comment.createdAt || comment.date || comment.created_at);
    const profileLink = nickname && nickname !== 'Аноним'
        ? `/profile/${encodeURIComponent(nickname)}`
        : null;
    const userSection = (
        <div className="review-user-section">
            {userId ? (
                <AccountHoverCard account={{ ...user, id: userId, nickname }}>
                    <ProfilePic isBig={false} account={{ ...user, id: userId, nickname }} />
                </AccountHoverCard>
            ) : (
                <div className="manga-comment-avatar" aria-hidden="true" />
            )}
            <p className="review-p">{nickname}</p>
        </div>
    );

    return (
        <div className="review manga-review">
            <div>
                <div className="review-con">
                    {dateText ? <p className="review-date">{dateText}</p> : null}
                </div>
                <p className="review-message">{text}</p>
                {profileLink ? (
                    <Link className="manga-comment-user-link" to={profileLink}>
                        {userSection}
                    </Link>
                ) : (
                    userSection
                )}
            </div>
        </div>
    );
};

MangaCommentComponent.propTypes = {
    comment: PropTypes.object,
};

export default MangaCommentComponent;
